<template>
	<div
		class="fellow-card"
		v-show="ownerComment && ownerComment.length"
		v-sd-exp:MallItemDetailExpo="{
			page: '二手车车辆详情页',
			sku_code: car.basic.commodity_code,
			store: 'PT004',
			module_name: this.car.basic.business_type === 1 ? '牛小二说' : '车主说',
			position_rank: 2,
			position_in_number: 1,
			position_in_rank: 1
		}"
	>
		<nio-profile
			size="small"
			:nioIcon="car.basic.business_type === 1"
			inline
			:name="nickname"
			:image="avatar"
			:jobTitle="jobTitle"
			@click="$emit('click')"
			@click-image="$emit('click')"
		/>

		<div class="fellow-message-box">
			<div class="message-box" v-html="ownerComment"></div>
		</div>
	</div>
</template>

<script>
import IconMessageBox from '@/assets/svg/message-box.svg'

export default {
	name: 'FellowCard',
	props: ['car'],
	data() {
		return {
			IconMessageBox
		}
	},
	computed: {
		nickname() {
			return this.car.basic.business_type === 1 ? '牛小二' : this.car.basic.nickname
		},
		avatar() {
			return this.car.basic.business_type === 1
				? 'https://cdn-app.nio.com/user/2022/5/23/4092f373-6d51-4d88-ad76-0d24cc1ac93c.jpeg'
				: this.car.basic.head_image
		},
		jobTitle() {
			return this.car.basic.business_type === 1 ? '二手车买卖童叟无欺' : '原车主（卖家）'
		},
		ownerComment() {
			let comment = this.car.basic.owner_comment || ''
			if (this.car.basic.business_type !== 1 && this.car.basic.maintain_information) {
				if (this.car.basic.owner_comment) {
					comment += '；'
				}
				comment += this.car.basic.maintain_information
			}

			return comment.replace(/\n/g, '<br />')
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.fellow-card {
	margin-top: 52px;

	.fellow-message-box {
		margin-top: 15px;
		padding: 15px;
		background-color: $bg_secondary;
		position: relative;

		.message-box {
			z-index: 10;
			color: $text_secondary;
			@include body_2(1.8, 400, false);
			background-image: url('../../assets/svg/message-box.svg');
			background-repeat: no-repeat;
			background-position: right bottom;
			word-break: break-all;
		}
	}
}
</style>
